import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel-result" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { style: {"margin":"10px 0 5px 0"} }, "Транспорт", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueGrid = _resolveComponent("CatalogueGrid")!
  const _component_PlanTransportGroupResultDetail3DJournal = _resolveComponent("PlanTransportGroupResultDetail3DJournal")!
  const _component_PlanTransportGroupResultDetailJournal = _resolveComponent("PlanTransportGroupResultDetailJournal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_CatalogueGrid, {
      summaryConfig: _ctx.summaryConfig,
      controller: 'PlanTransportGroupResult',
      columns: _ctx.columns,
      filterRowVisible: true,
      groupPanelVisible: true,
      headerFilterVisible: true,
      filterPanelVisible: false,
      showPageSizeSelector: !_ctx.selectMode,
      pageSize: 10,
      pageSizes: _ctx.pageSizes,
      editingConfig: _ctx.editingConfig,
      selectionConfig: _ctx.selectionConfig,
      designConfig: _ctx.designConfig,
      getSelectedData: _ctx.getSelectedData,
      changeSelectedData: _ctx.changeSelectedData,
      parentModel: _ctx.parentModel,
      selectMode: _ctx.selectMode,
      onRowPrepared: _ctx.onRowPrepared
    }, null, 8, ["summaryConfig", "columns", "showPageSizeSelector", "pageSizes", "editingConfig", "selectionConfig", "designConfig", "getSelectedData", "changeSelectedData", "parentModel", "selectMode", "onRowPrepared"]),
    (_ctx.showScheme3D)
      ? (_openBlock(), _createBlock(_component_PlanTransportGroupResultDetail3DJournal, {
          key: 0,
          parentModel: _ctx.parentModel
        }, null, 8, ["parentModel"]))
      : (_openBlock(), _createBlock(_component_PlanTransportGroupResultDetailJournal, {
          key: 1,
          parentModel: _ctx.parentModel
        }, null, 8, ["parentModel"]))
  ]))
}